var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-history-empty-state"},[_c('div',{staticClass:"nav-history-empty-state__icon"},[_c('i',{class:_vm.icon_class})]),_c('p',{staticClass:"nav-history-empty-state__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"nav-history-empty-state__hint"},[_vm._v(" "+_vm._s(_vm.hint)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }